export const DEFAULT_ITEMS_REQUEST = 25;

export interface OrdsQueryParams {
  q?: any;
  limit?: number;
  offset?: number;
}

export interface CreateSimpleRequestOptions {
  searchAttributesArray?: string[];
  limitItemsRequest?: number;
  useEntities?: boolean;
  truncateEntities?: number;
  idField?: string;
}
export interface SimpleRequestOptions {
  search?: string;
  entities?: any[];
  idx?: number[];
}

/**
 * Business function. make query params function for simple API call.
 * @param {array} searchAttributesArray the attributes to search in
 * @param limit
 * @param {boolean} useEntities
 * @returns {function({search?: *, entities?: *, idx: *}): ({q: {$or: *}})} The makeQueryParams function.
 */
export function createSimpleRequest({
  searchAttributesArray = [],
  limitItemsRequest,
  useEntities,
  truncateEntities,
  idField,
}: CreateSimpleRequestOptions) {
  return ({ search, entities, idx }: SimpleRequestOptions): OrdsQueryParams => {
    const AndQueryParams = [];
    let queryParams = null;

    if (idField && idx && idx.length > 0) {
      const searchedIdx = idx.map((id) => {
        return { [idField]: { $eq: `${id}` } };
      });
      return {
        q: { $or: searchedIdx },
      };
    }

    if (useEntities && entities && entities.length > 0) {
      const entitiesFilters = entities.map((ent) => {
        return {
          entity_nav_full_id: {
            $like: `${
              truncateEntities
                ? ent.nav_full_id.slice(0, truncateEntities)
                : ent.nav_full_id
            }%`,
          },
        };
      });

      AndQueryParams.push({ $or: entitiesFilters });
    }

    let searchParams = null;
    if (search) {
      searchParams = searchAttributesArray.map((attribute) => {
        return {
          [attribute]: { $instr: `${search}` },
        };
      });

      AndQueryParams.push({ $or: searchParams });
    }

    const limit = limitItemsRequest || DEFAULT_ITEMS_REQUEST;

    if (AndQueryParams.length > 0) {
      queryParams = {
        q: {
          $and: AndQueryParams,
        },
        limit,
      };
    }
    return queryParams;
  };
}
